import React from "react";

export function LoadingCard(){
    return (
        <div className="loading-card">
        </div>
    )
}